import { createSlice } from "@reduxjs/toolkit";
import { API_STATUS } from "../../../constants/apiStatus";
import { getUserWorkoutPlansAction } from "./workoutPlansSliceActions";
import { workoutPlansSliceInitialState } from "./workoutPlansSliceInitialState";

const initialState = workoutPlansSliceInitialState;

const workoutPlansSlice = createSlice({
  name: "workoutPlans",
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    setSelectedPlan: (state, action) => {
      state.selectedPlan = action.payload;
    },
    clearSelectedPlan: (state) => {
      state.selectedPlan = null;
    },
    resetWorkoutPlansState: () => initialState,
  },
  extraReducers: (builder) => {
    // Get User Workout Plans
    builder.addCase(getUserWorkoutPlansAction.fulfilled, (state, action) => {
      state.apiStatus.getUserWorkoutPlans = API_STATUS.COMPLETED;

      if (action.payload && action.payload.success) {
        state.workoutPlans = action.payload.workoutPlans || [];
        state.total = action.payload.total || 0;
        state.userId = action.payload.userId || null;
      } else {
        state.workoutPlans = [];
        state.total = 0;
      }

      state.error = null;
    });
    builder.addCase(getUserWorkoutPlansAction.pending, (state) => {
      state.apiStatus.getUserWorkoutPlans = API_STATUS.STARTED;
      state.error = null;
    });
    builder.addCase(getUserWorkoutPlansAction.rejected, (state, action) => {
      state.apiStatus.getUserWorkoutPlans = API_STATUS.FAILED;
      state.error = action.payload;
      state.workoutPlans = [];
      state.total = 0;
    });
  },
});

export const {
  clearError,
  setSelectedPlan,
  clearSelectedPlan,
  resetWorkoutPlansState,
} = workoutPlansSlice.actions;

export default workoutPlansSlice.reducer;
